const DAY_MS = 24 * 60 * 60 * 1000;
const MAX_INITIAL_AGE_DAYS = 1095;

export const AGE_PRESETS = [
  { value: 0, label: 'Day-old chicks (0 days)' },
  { value: 7, label: '1 week old' },
  { value: 14, label: '2 weeks old' },
  { value: 28, label: '4 weeks old' },
  { value: 140, label: 'Point of lay (~20 weeks)' }
];

export const apiDateToInput = (value) => {
  if (!value) return '';
  const s = String(value);
  if (/^\d{4}-\d{2}-\d{2}/.test(s)) return s.slice(0, 10);
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '';
  return d.toISOString().slice(0, 10);
};

export const todayInputValue = () => new Date().toISOString().slice(0, 10);

export const dateInputToApi = (dateStr) => {
  const day = apiDateToInput(dateStr) || todayInputValue();
  // Noon UTC keeps the calendar day stable in both Kenya and US timezones.
  return `${day}T12:00:00.000Z`;
};

export const biologicalAgeDays = (startDate, initialAgeDays = 0) => {
  const api = dateInputToApi(startDate);
  const elapsed = Math.floor((Date.now() - new Date(api).getTime()) / DAY_MS);
  return Math.max(0, Number(initialAgeDays) || 0) + Math.max(0, elapsed);
};

export const formatAge = (days) => {
  const n = Math.max(0, Math.round(Number(days) || 0));
  if (n < 14) return `${n} day${n === 1 ? '' : 's'}`;
  const weeks = Math.round(n / 7);
  return `${n} days (~${weeks} week${weeks === 1 ? '' : 's'})`;
};

export const targetAgeOptions = (type, subtype, initialAgeDays = 0) => {
  const min = Number(initialAgeDays) || 0;
  let options = [];
  if (type === 'broiler') options = [35, 42, 49, 56];
  else if (type === 'layer') options = [504, 560];
  else if (type === 'dual') {
    if (subtype === 'kienyeji_improved') options = [84, 98, 112, 126];
    else if (subtype === 'kienyeji_pure') options = [112, 126, 168];
    else options = [84, 98, 112, 126, 168];
  }
  return options.filter((v) => v > min);
};

export const labelTargetAge = (v) =>
  `${v} days${v % 7 === 0 ? ` (${Math.round(v / 7)} weeks)` : ''}`;

export const recommendedTarget = (type, subtype, initialAgeDays = 0) => {
  const options = targetAgeOptions(type, subtype, initialAgeDays);
  return options[0] ?? '';
};

export const parseAgeDays = (value) => {
  if (value === '' || value === null || value === undefined) return 0;
  const n = Number(value);
  if (!Number.isFinite(n) || n < 0) return 0;
  return Math.min(MAX_INITIAL_AGE_DAYS, Math.round(n));
};

export { MAX_INITIAL_AGE_DAYS };
